import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-silos',
  templateUrl: './data-silos.component.html',
  styleUrls: ['./data-silos.component.sass']
})
export class DataSilosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
